export default __webpack_public_path__ + "static/media/sensoan_logo_blue.0d04c527.png";